import React, { useCallback, useContext, useEffect, useState } from "react";
import ProductionScrollBar from "./ProductionScrollBar";
import ProductionDetails from "./ProductionDetails";
import { useParams } from "react-router-dom";
import { productionService } from "../../services/productionService";
import { useLocation, useNavigate } from "react-router-dom";
import { create } from "react-modal-promise";
import GeneralModal from "../../helpers/GeneralModal";
import LogicContext from "../../Context/LogicContext";
import { Dropdown } from "react-bootstrap";


import { SetProductionEdit , GetProductionAtomData, SetProductionAtomData} from "../../store/productionAtom";
import { isArray } from "lodash";


const ProductionDetailsPage = () => {
    const { id } = useParams();
  const [prodDetails, setProdDetails] = useState({});
  const [productionList, setProductionList] = useState([]);
  const [actionData, setActionData] = useState([]);
    const { pathname } = useLocation();
      const navigate = useNavigate();
          const setProductionAtomData = SetProductionAtomData();
          
      const setProductionEdit = SetProductionEdit();
      const getProductionAtomData = GetProductionAtomData();
      const setProductionAtom = SetProductionAtomData();
        const myPromiseModal = create(GeneralModal);
                 const logicContext = useContext(LogicContext);
  
    var url = pathname.split("/");
    const currModuleId = url[1];
    const currModuleName = url[2];
    const currUserMenu = url[3];



    useEffect(() => {
      document.title = "Production Details Page";
      loadDetails(id);
      return () => {};
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id]);

     useEffect(()=> {
        if(!getProductionAtomData.production_info?.length){
          loadDataFromServer();
        }
  
    },[getProductionAtomData.production_info]);
  

  const items = [
    { name: "Beans", refNo: "1001", qty: 5, date: "01/01/2025" },
    // ...more items
  ];



  const onProductSelect = (product)=> {
    const {Ref_No} = product;
    navigate(
      `/${currModuleId}/${currModuleName}/${currUserMenu}/details/${Ref_No}`
    );
    // setProdDetails(product)

  }


  const loadDetails =  async(id) => {
        const response =  await  productionService.productionDetails(id);
        const {required_item_info  , production_info, Action_Status} = response.data;
        if(Array.isArray(production_info) && production_info?.length){
            setProdDetails(production_info[0]);
        }
        if(Array.isArray(required_item_info) && required_item_info?.length){
            setProductionList(required_item_info);
        }
        if(Array.isArray(Action_Status) && Action_Status?.length){
            setActionData(Action_Status);
        }else{
          setActionData([]);
        }
  }
 


    const modifyProduction = async()=> {
      const result = await myPromiseModal({ title: "Confirmation",  body: " Do you want to save this record?",
        showInput: false,  placeHolder: "", });
        if(result?.decision === false){
          return ;// User choose not to submit the form
        }

        setProductionEdit({...prodDetails,itemList:productionList?.length ? productionList: [] });
        navigate( `/${currModuleId}/${currModuleName}/${currUserMenu}/add-new`);
    }
  
  
    const deleteProduction = async()=> {
      const result = await myPromiseModal({ title: "Confirmation",  body: " All information related to this production will be deleted!",
        showInput: false,  placeHolder: "", });
        if(result?.decision === false){
          return ;// User choose not to submit the form
        }

        productionService.deleteProduction(id).then((response)=> {
          const cleanResponse =  logicContext.httpResponseManager(response.data?.[0] || response.data?.result_status?.[0]);
          logicContext.showToast(cleanResponse?.message_text, 'success');
          if(cleanResponse?.message_id == 1){
                const newList =  getProductionAtomData.production_info.filter((prod)=> prod?.Ref_No != id);
                  setProductionAtom((prev)=> {
                    return {...prev, production_info:newList }
                  });
                  navigate(-1);

          }
  

        }).catch((err)=> {
      logicContext.showToast("Delete error", 'error');
        })
    }



    const onAddNewProduction = ()=> {
      navigate( `/${currModuleId}/${currModuleName}/${currUserMenu}/add-new`);
    }
  


    const loadDataFromServer = ()=>{
        productionService.getProductionList().then((res)=> {
          if( isArray(res?.data?.production_info) && res?.data?.production_info?.length){
            setProductionList(res.data?.production_info);
            setProductionAtomData(res.data);
          }
         }).catch((err)=> {
          logicContext.showToast("data not loaded!", "");
         });
      }


    const processItemSetup = async () => {
        const result = await myPromiseModal({ title: "Confirmation",  body: " Process setup for this item?",
        showInput: false,  placeHolder: "", });
        if(result?.decision === false){
          return ;// User choose not to submit the form
        }

    navigate(`/${currModuleId}/${currModuleName}/production-setup/add-new?productionId=${id}`);
  };



     const singleActionPerform = useCallback(
          async action => {
            const result = await myPromiseModal({
              title: 'Confirm your action!',
              body: `This Production status will be ${action.status_name}?`,
              showInput: false,
              placeHolder: 'Enter message',
            });
    
            console.log("res ", result);
     
      
            if (result.decision === true) {
              const formData = { ref_no: id, option: action.action_option };
              productionService.productionAction(formData)
                .then(res => {
                  if (res?.data !== undefined) {
                    const cleanResponse = logicContext.httpResponseManager(res.data?.[0] || res.data?.result_status?.[0]);
                    const { message_id, message_text } = cleanResponse;
  
                    if (message_id == 1) {
                      logicContext.showToast(message_text, 'success');
                            loadDetails(id);

                    }
                  }
                })
                .catch(err => {
                  logicContext.showToast("error", 'error');
                });
            }
          },
          [myPromiseModal]
        );
    


  return (
    <div className="flex h-screen">
      <ProductionScrollBar
        items={items}
        onSelect={onProductSelect}
      />
      <ProductionDetails actionData={actionData} singleActionPerform={singleActionPerform} processItemSetup={processItemSetup} onAddNewProduction={onAddNewProduction} deleteProduction={deleteProduction} modifyProduction={modifyProduction}
       productionList={productionList}  prodDetails={prodDetails} />
    </div>
  );
};

export default ProductionDetailsPage;
